import { TextField, ValidationErrors } from "@compass/core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { DatePickerProps as MuiDatePickerProps } from "@mui/x-date-pickers/DatePicker";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { displayErrorMessages, getErrorMessages } from "../common/input-functions";

export type DatePickerBaseProps = Omit<MuiDatePickerProps<Date, Date>, "value" | "onChange" | "renderInput"> & {
  label?: string;
  value?: any;
  onChange?: (date: any | undefined, keyboardInputValue?: string) => void;
  errors?: ValidationErrors | string[];
  required?: boolean;
  size?: "small" | "medium" | undefined;
  disabled?: boolean;
  autoFocus?: boolean;
};

export const DatePickerBase = ({
  label,
  value,
  onChange,
  size = "medium",
  errors,
  required,
  disabled,
  autoFocus,
  ...rest
}: DatePickerBaseProps) => {
  const errorMsg = getErrorMessages(errors);
  const hasError = errorMsg?.length > 0 ? true : false;

  const handleChange = (dateValue) => {
    onChange?.(dateValue ? dateValue.format("YYYY-MM-DD") : null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDatePicker
        label={label}
        value={value || null} // || null to prevent auto prefill today's date when adding a new listItem: why?
        onChange={handleChange}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            required={required}
            variant={"outlined"}
            error={params.error ? params.error : hasError}
            helperText={displayErrorMessages(errorMsg)}
            size={size}
            autoComplete="off"
            autoFocus={autoFocus}
          />
        )}
        {...rest}
      />
    </LocalizationProvider>
  );
};
